import { SVGProps, Ref, forwardRef } from 'react';

export const EmojiHalfsmileOutlinedSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    d="M7.032 10.664c0 .098.039.21.143.32.158.169.45.313.823.313s.665-.144.823-.312a.47.47 0 0 0 .143-.32h1.4c0 .501-.209.944-.523 1.278-.45.48-1.126.754-1.843.754s-1.393-.274-1.843-.754a1.86 1.86 0 0 1-.523-1.279z"
                    fill="currentColor"
                />
                <path
                    d="M4.677 5.466c.205-.246.527-.4.988-.4.462 0 .784.154.988.4.202.242.279.56.279.866s-.077.623-.279.865c-.204.246-.526.4-.988.4s-.783-.154-.988-.4c-.202-.242-.278-.559-.278-.865 0-.307.076-.624.278-.866"
                    fill="currentColor"
                />
                <path
                    d="M9.343 5.466c.204-.246.526-.4.988-.4s.783.154.988.4c.202.242.278.56.278.866s-.076.623-.278.865c-.205.246-.527.4-.988.4-.462 0-.784-.154-.988-.4-.202-.242-.279-.559-.279-.865 0-.307.077-.624.279-.866"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 .5C1.438.5.5 1.438.5 8s.938 7.5 7.5 7.5 7.5-.937 7.5-7.5S14.563.5 8 .5M2.125 4.319C1.96 5.192 1.9 6.37 1.9 8s.06 2.808.225 3.681c.162.86.4 1.287.654 1.54.253.253.68.492 1.54.654.873.165 2.051.225 3.681.225s2.808-.06 3.681-.225c.86-.162 1.287-.4 1.54-.654.253-.253.492-.68.654-1.54.165-.873.225-2.051.225-3.681s-.06-2.808-.225-3.681c-.162-.86-.4-1.287-.654-1.54-.253-.253-.68-.492-1.54-.654C10.808 1.96 9.63 1.9 8 1.9s-2.808.06-3.681.225c-.86.162-1.287.4-1.54.654-.253.253-.492.68-.654 1.54"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
EmojiHalfsmileOutlinedSize16Glyph.displayName = 'EmojiHalfsmileOutlinedSize16Glyph';
